<template>
  <div class="box rounded-lg">
    <div class="circle">
      <div
        ref="water"
        class="water"
        :style="`top: ${110 - (value * 1.3)}%`"
      />
    </div>
    <input
      v-model="value"
      type="range"
      min="0"
      max="100"
      value="0"
    >
    {{ value }}
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: 25
    }
  },
}
</script>

<style scoped>
:root {
  --water-y: 0%;
}

.box {
  height: calc(100%);
  background-color: rgb(100, 100, 100);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.circle {
  position: relative;
  height: 200px;
  width: 200px;
  border-radius: 50%;
  background-color: white;
  /* 原理: 通过overflow */
  overflow: hidden;
  /* overflow: visible; */
}

/* 自旋转动画 */
@keyframes rotate {
  0% {
    transform: translate(-50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%) rotate(360deg);
  }
}

.water {
  position: absolute;
  /* top: 0; */
  left: 50%;
  height: 300px;
  width: 300px;
  border-radius: 35%;
  background-color: rgb(83, 226, 255);
  animation: rotate 3s linear infinite;
}

</style>